/**
 * Who am I, on this outing?
 *
 * There are no accounts. Opening the link asks which participant you are, the
 * same way Tricount does, and this remembers the answer per outing. The stored
 * value is a member id, which is identity rather than proof: it says whose
 * entries to treat as yours, and because the id belongs to the person and not to
 * the browser, opening the link on a second device and picking the same name
 * gives you back your car and your seat.
 *
 * The organiser's admin token is a real credential and is kept separately; it is
 * what still guards deleting the outing or removing someone else's car.
 */

const KEY = 'covoiturage.v2';

function readAll() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || '{}');
  } catch {
    return {}; // private mode, disabled storage, corrupt value: degrade gracefully
  }
}

function writeAll(data) {
  try {
    localStorage.setItem(KEY, JSON.stringify(data));
  } catch {
    /* the app still works; you will just be asked who you are again */
  }
}

const blank = () => ({ adminToken: null, memberId: null });

export function getTripIdentity(shareToken) {
  const all = readAll();
  return { ...blank(), ...(all.trips?.[shareToken] ?? {}) };
}

function patchTrip(shareToken, patch) {
  const all = readAll();
  all.trips ??= {};
  all.trips[shareToken] = { ...blank(), ...(all.trips[shareToken] ?? {}), ...patch };
  writeAll(all);
  return all.trips[shareToken];
}

export const rememberAdmin = (shareToken, adminToken) => patchTrip(shareToken, { adminToken });
export const rememberMember = (shareToken, memberId) => patchTrip(shareToken, { memberId });
export const forgetMember = (shareToken) => patchTrip(shareToken, { memberId: null });

/** Pre-fills the name box, so a regular user types their name once per browser. */
export const getDisplayName = () => readAll().displayName ?? '';
export function setDisplayName(name) {
  const all = readAll();
  all.displayName = String(name || '').slice(0, 80);
  writeAll(all);
}

/** Outings this browser has opened, for the landing page's "recent" list. */
export function rememberVisit(shareToken, title) {
  const all = readAll();
  all.recent = [
    { shareToken, title, at: new Date().toISOString() },
    ...(all.recent ?? []).filter((r) => r.shareToken !== shareToken),
  ].slice(0, 6);
  writeAll(all);
}
export const getRecent = () => readAll().recent ?? [];
